module.exports = __webpack_public_path__ + "assets/b20.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b20.png
// module id = 606
// module chunks = 0